enum LinksEnum {
    Documentation = "/documentation",
    Framework = "/documentation/framework",
    PromptEngineeringAnchor = "/documentation/prompt-engineering#prompt-engineering",

    Workshop = "/workshop",
}

export default LinksEnum;